/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Notetaker_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo writes your report as soon as the recording is processed." |
*
* @param {Meeting_Report_Notetaker_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_notetaker_body = /** @type {((inputs?: Meeting_Report_Notetaker_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Notetaker_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo schrijft je verslag zodra de opname verwerkt is.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rédige votre compte rendu dès que l'enregistrement est traité.")
	return /** @type {LocalizedString} */ ("Wundo writes your report as soon as the recording is processed.")
});